/* [BD] Compare — sync row heights across left, center pill, and right columns. */
;(function () {
  var bdCompareDesktopMq = window.matchMedia('(min-width: 750px)');
  var BD_COMPARE_DEBUG =
    window.BD_COMPARE_DEBUG === true || /[?&]bd_compare_debug=1/.test(window.location.search);

  function bdCompareLog(label, payload) {
    if (!BD_COMPARE_DEBUG) return;
    if (payload !== undefined) {
      console.log('[BD Compare]', label, payload);
    } else {
      console.log('[BD Compare]', label);
    }
  }

  function bdComparePanelMetrics(el, name) {
    if (!el) return { name: name, missing: true };
    var style = getComputedStyle(el);
    return {
      name: name,
      offsetHeight: el.offsetHeight,
      clientHeight: el.clientHeight,
      scrollHeight: el.scrollHeight,
      minHeight: style.minHeight,
      height: style.height,
      alignSelf: style.alignSelf,
      paddingTop: style.paddingTop,
      paddingBottom: style.paddingBottom,
      boxSizing: style.boxSizing,
      gridTemplateRows: style.gridTemplateRows,
    };
  }

  function bdCompareSyncContext(root) {
    var sync = root.querySelector('.bd_compare__sync');
    if (!sync) return null;
    var syncStyle = getComputedStyle(sync);
    return {
      isDesktop: bdCompareDesktopMq.matches,
      usesSubgrid: usesBdCompareSubgrid(),
      rowCount: sync.style.getPropertyValue('--bd-compare-row-count') || syncStyle.getPropertyValue('--bd-compare-row-count'),
      extraHeight: getBdCompareLeftExtraHeight(root),
      syncAlignItems: syncStyle.alignItems,
      syncClasses: sync.className,
    };
  }

  function resetBdCompareRowHeights(root) {
    root.querySelectorAll('[data-bd-compare-line]').forEach(function (cell) {
      cell.style.minHeight = '';
    });

    root.querySelectorAll('.bd_compare__sync-left, .bd_compare_parent_columns').forEach(function (panel) {
      panel.style.minHeight = '';
      panel.style.marginTop = '';
    });
  }

  function getBdCompareLeftExtraHeight(root) {
    var sync = root.querySelector('.bd_compare__sync');
    if (!sync) return bdCompareDesktopMq.matches ? 15 : 18;

    var extra = parseFloat(getComputedStyle(sync).getPropertyValue('--bd-compare-left-extra-height'));
    return Number.isFinite(extra) ? extra : bdCompareDesktopMq.matches ? 15 : 18;
  }

  function usesBdCompareSubgrid() {
    if (!bdCompareDesktopMq.matches) return false;
    if (typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
    return CSS.supports('grid-template-rows', 'subgrid');
  }

  function syncBdComparePanelHeights(root, passLabel) {
    var left = root.querySelector('.bd_compare__sync-left');
    var parent = root.querySelector('.bd_compare_parent_columns');
    var wrap = root.querySelector('.bd_compare__sync-right-wrap');
    if (!left || !parent) return;

    bdCompareLog('panel sync start' + (passLabel ? ' (' + passLabel + ')' : ''), bdCompareSyncContext(root));

    left.style.minHeight = '';
    parent.style.minHeight = '';
    parent.style.marginTop = '';

    var parentHeight = parent.offsetHeight;
    var leftHeight = left.offsetHeight;

    bdCompareLog('panel natural heights (after reset)', {
      extra: getBdCompareLeftExtraHeight(root),
      parentHeight: parentHeight,
      leftHeight: leftHeight,
      parent: bdComparePanelMetrics(parent, 'parent'),
      left: bdComparePanelMetrics(left, 'left'),
    });

    if (parentHeight <= 0 && leftHeight <= 0) {
      bdCompareLog('panel sync skipped — no measurable height');
      return;
    }

    /* Extra left height comes from CSS padding-bottom; only bump min-height if content is shorter. */
    if (parentHeight > 0 && leftHeight < parentHeight) {
      left.style.minHeight = parentHeight + 'px';
    }

    bdCompareLog('panel min-heights applied', {
      parentHeight: parentHeight,
      leftHeight: left.offsetHeight,
      leftMinHeight: left.style.minHeight || 'auto',
      wrap: wrap ? bdComparePanelMetrics(wrap, 'wrap') : null,
      parent: bdComparePanelMetrics(parent, 'parent'),
      left: bdComparePanelMetrics(left, 'left'),
    });
  }

  function shouldApplyBdCompareLineMinHeight(cell) {
    return !cell.classList.contains('bd_compare__pill');
  }

  function syncBdCompareRowHeights(root) {
    if (!root) return;

    resetBdCompareRowHeights(root);

    bdCompareLog('row sync path', 'JS line min-heights');

    var lineMap = Object.create(null);

    root.querySelectorAll('[data-bd-compare-line]').forEach(function (cell) {
      var line = cell.getAttribute('data-bd-compare-line');
      if (!line) return;
      if (!lineMap[line]) lineMap[line] = [];
      lineMap[line].push(cell);
    });

    Object.keys(lineMap).forEach(function (line) {
      var cells = lineMap[line];
      var maxHeight = 0;

      cells.forEach(function (cell) {
        maxHeight = Math.max(maxHeight, cell.offsetHeight);
      });

      if (maxHeight <= 0) return;

      cells.forEach(function (cell) {
        if (!shouldApplyBdCompareLineMinHeight(cell)) return;
        cell.style.minHeight = maxHeight + 'px';
      });

      bdCompareLog('row line ' + line, {
        maxHeight: maxHeight,
        cells: cells.map(function (cell) {
          return {
            className: cell.className,
            offsetHeight: cell.offsetHeight,
            minHeight: getComputedStyle(cell).minHeight,
          };
        }),
      });
    });

    root.classList.add('bd_compare__sync--aligned');
    syncBdComparePanelHeights(root, 'after row sync');
    applyBdCompareRowMinHeights(root);
  }

  function applyBdCompareRowMinHeights(root) {
    var lineMap = Object.create(null);

    root.querySelectorAll('[data-bd-compare-line]').forEach(function (cell) {
      var line = cell.getAttribute('data-bd-compare-line');
      if (!line) return;
      if (!lineMap[line]) lineMap[line] = [];
      lineMap[line].push(cell);
    });

    Object.keys(lineMap).forEach(function (line) {
      var cells = lineMap[line];
      var maxHeight = 0;

      cells.forEach(function (cell) {
        cell.style.minHeight = '';
      });

      cells.forEach(function (cell) {
        maxHeight = Math.max(maxHeight, cell.offsetHeight);
      });

      if (maxHeight <= 0) return;

      cells.forEach(function (cell) {
        if (!shouldApplyBdCompareLineMinHeight(cell)) return;
        cell.style.minHeight = maxHeight + 'px';
      });
    });
  }

  function scheduleBdCompareSync(root) {
    if (!root) return;
    if (root._bdCompareSyncFrame) {
      cancelAnimationFrame(root._bdCompareSyncFrame);
    }
    root._bdCompareSyncFrame = requestAnimationFrame(function () {
      root._bdCompareSyncFrame = null;
      bdCompareLog('schedule — frame 1');
      syncBdCompareRowHeights(root);
      requestAnimationFrame(function () {
        bdCompareLog('schedule — frame 2');
        syncBdComparePanelHeights(root, 'raf 2');
        applyBdCompareRowMinHeights(root);
        requestAnimationFrame(function () {
          bdCompareLog('schedule — frame 3 (final)');
          syncBdComparePanelHeights(root, 'raf 3 final');
          applyBdCompareRowMinHeights(root);
        });
      });
    });
  }

  function bindBdCompareSync(root) {
    if (!root || root._bdCompareSyncBound) return;
    root._bdCompareSyncBound = true;

    if (BD_COMPARE_DEBUG) {
      console.log(
        '[BD Compare] Debug enabled. Filter console by "[BD Compare]" or set window.BD_COMPARE_DEBUG = false to disable.'
      );
    }

    scheduleBdCompareSync(root);

    if (typeof ResizeObserver === 'function') {
      var observer = new ResizeObserver(function () {
        scheduleBdCompareSync(root);
      });
      observer.observe(root);
      root._bdCompareResizeObserver = observer;
    } else {
      window.addEventListener('resize', function () {
        scheduleBdCompareSync(root);
      });
    }

    if (typeof bdCompareDesktopMq.addEventListener === 'function') {
      bdCompareDesktopMq.addEventListener('change', function () {
        scheduleBdCompareSync(root);
      });
    } else if (typeof bdCompareDesktopMq.addListener === 'function') {
      bdCompareDesktopMq.addListener(function () {
        scheduleBdCompareSync(root);
      });
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready
        .then(function () {
          scheduleBdCompareSync(root);
        })
        .catch(function () {});
    }
  }

  function initBdCompareSections(scope) {
    var root = scope && scope.querySelector ? scope : document;
    root.querySelectorAll('[data-bd-compare-sync]').forEach(bindBdCompareSync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initBdCompareSections(document);
    });
  } else {
    initBdCompareSections(document);
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      if (!event || !event.target) return;
      initBdCompareSections(event.target);
    });
  }
})();
